import { SmartTableColumn, WithNAFallback } from '@toggle/design-system';
import { EarningsInsightRating, ManagementInsight } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { RatingPill } from '~/widgets/earnings-insight-drawer/earnings-insight-widget/components/rating-pill/RatingPill';
import { SharedTable } from '~/widgets/earnings-insight-drawer/earnings-insight-widget/components/shared-table/SharedTable';

import * as S from './StrategicInsights.styles';

interface StrategicInsightsProps {
  managementInsights: ManagementInsight[];
}

export const StrategicInsights = ({
  managementInsights,
}: StrategicInsightsProps) => {
  const { t } = useTranslation(['earnings']);

  const tableColumns: SmartTableColumn<ManagementInsight>[] = [
    {
      key: 'title',
      label: t('earningsInsight.drawer.earningsRecap.tables.area'),
      render: (value: string) => <S.StyledTitleCell>{value}</S.StyledTitleCell>,
    },
    {
      key: 'description',
      label: t(
        'earningsInsight.drawer.earningsRecap.tables.managementTakeaway'
      ),
      render: (value: string) => (
        <WithNAFallback
          check={value !== undefined && value !== ''}
          value={<S.StyledDescriptionCell>{value}</S.StyledDescriptionCell>}
        />
      ),
    },
    {
      key: 'rating',
      label: t('earningsInsight.drawer.earningsRecap.tables.impactAssessment'),
      render: (value: EarningsInsightRating) => (
        <WithNAFallback
          check={!!value}
          value={
            <S.StyledRatingPill>
              <RatingPill rating={value} />
            </S.StyledRatingPill>
          }
        />
      ),
    },
  ];

  return (
    <div>
      <S.Title>
        {t('earningsInsight.drawer.earningsRecap.items.managementCommentary')}
      </S.Title>
      <SharedTable
        tableData={managementInsights.map(i => ({
          ...i,
          key: i.title,
        }))}
        tableColumns={tableColumns}
        noCellPadding
      />
    </div>
  );
};
